/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnEdward.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnEdward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnEdward-view">
        <Helmet>
          <title>创办人 - 赖钧豪 - CheckPlus</title>
        </Helmet>

        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}

        {renderHomePageHeader(this)}

        <div className="CnEdward-first">
          <Link to="/CnTeam">
            <div className="CnEdward-back">
              <div className="CnEdward-backBtn"></div>
              <div className="CnEdward-backText">返回</div>
            </div>
          </Link>

          <div className="CnEdwardContainer">
            <div className="CnEdward-edwardPic" />

            <div className="CnEdward-name">
              <strong>赖钧豪 Edward Lai</strong>
              <br />
              创办人、行政总裁兼首席设计师
            </div>
          </div>
        </div>

        <div className="CnEdward-second">
          <div className="CnEdward-secondText">
            赖钧豪 Edward Lai 是 CheckPlus 的创办人、行政总裁兼首席设计师。
            <p />
            在成立 CheckPlus 之前，Edward曾在澳洲和美国生活和学习。
            他决定回到香港，为他多年来积累的知识和技能做出贡献。
            <p />
            Edward
            将大部分时间投放在与许多香港非牟利机构紧密合作上，他希望透过CheckPlus向非牟利机构提供技术解决方案，回馈社区。
            <p />
            在2019年，他与香港的许多非牟利机构会面，而 CheckPlus
            网上捐款平台已被30多间非牟利机构使用。
            <p />
            Edward 获得了加州大学圣巴巴拉分校 (University of California, Santa
            Barbara) 的社会学学士学位。
          </div>
        </div>

        <div className="CnEdward-footer">
          <div className="CnEdward-footerNav">
            <Link to="/CnTeam">
              <div className="CnEdward-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnEdward-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnEdward-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnEdward-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnEdward-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnEdward-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnEdward;
